import React, { useCallback } from "react";
import { Button, toast } from "@jsq/ds/core";
import {
  PaymentServicePaymentBatchStatus,
  useDenyPaymentBatchMutation,
} from "../../../graphql/supergraph.index";
import { clientContext } from "../../../utils/graphql_utils";
import { denyButton } from "../styles_vanilla.css";

interface PaymentDenyButtonProps {
  paymentBatchId: string;
  disabled: boolean;
  deniedCallback: (data: PaymentServicePaymentBatchStatus) => void;
}

const PaymentDenyButton: React.FC<PaymentDenyButtonProps> = ({
  paymentBatchId,
  disabled,
  deniedCallback,
}) => {
  const [denyPaymentBatch, { loading }] = useDenyPaymentBatchMutation({
    context: clientContext(),
    variables: { paymentBatchId: paymentBatchId },
    onError: (err) => {
      toast.error(err.message);
    },
    onCompleted: (data) => {
      deniedCallback(data.denyCanopyPaymentBatch.status);
    },
  });
  const handleDenyPayment = useCallback(async () => {
    await denyPaymentBatch();
  }, [denyPaymentBatch]);

  return (
    <Button
      data-testid="denyButton"
      className={denyButton}
      variant="neutral"
      disabled={disabled}
      isLoading={loading}
      onClick={() => {
        void handleDenyPayment();
      }}
    >
      Deny
    </Button>
  );
};
export default PaymentDenyButton;
